import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IntercomModule } from '@y42/intercom';
import { GojsOverviewComponent } from './gojs-overview.component';

@NgModule({
  imports: [CommonModule, IntercomModule, MatTooltipModule, FontAwesomeModule],
  declarations: [GojsOverviewComponent],
  exports: [GojsOverviewComponent],
})
export class GojsOverviewModule {}
